import React, { useEffect } from 'react';
import CenteredSkeleton from './common/CenteredSkeleton.jsx';
import SkeletonComponent from './common/SkeletonComponent.jsx';
import "react-loading-skeleton/dist/skeleton.css";

const FormViewerSkeleton = () => {
  const resize = () => {
    let editor = jQuery('.form-editor');

    if (editor.length > 0) {
      let bottomPadding = jQuery(window).width() < 768 ? 130 : 60;
      editor.find('.panes').css({
        height: (jQuery(window).height() - editor.offset().top - editor.find('.bottom').outerHeight(true) - bottomPadding) + 'px'
      });
    }
  }

  useEffect(() => {
    resize();
  }, [])

  return (
    <div className='form-viewer-skeleton'>
      <div className='components'>
        <div className='form-component' style={{height: 63}}>
          <SkeletonComponent width='100%' height='90%' />
        </div>
        <div className='form-component' style={{marginTop: -3}}>
          <CenteredSkeleton width='100%' height='15px' />
        </div>
        <div className='page'>
          <SkeletonComponent width='100%' height='calc(50vh - 150px)' />          
        </div>
      </div>
    </div>
  )
}

export default FormViewerSkeleton;